import { computed, getCurrentInstance } from 'vue';

const useAppResourcesHook = () => {
  const { proxy } = getCurrentInstance();

  const appLegalResources = computed(() => ({
    terms: proxy.$_translateByOperator('link_terms_and_conditions') || '',
    privacy: proxy.$_translateByOperator('link_privacy_and_policy') || '',
  }));

  return {
    appLegalResources,
  };
};

export default useAppResourcesHook;
